import { CogWrapper } from './style'
import { Cog } from '@styled-icons/boxicons-solid'

export default () => {
    return (
        <CogWrapper onClick={() => {}}>
            <Cog id={'optionBtn'} width={'35px'}  color={'#fff'} />
        </CogWrapper>
    )
}